import { v2Api } from './v2Client';

const get = (url, config) => v2Api.get(url, config).then((r) => r.data);
const post = (url, body) => v2Api.post(url, body).then((r) => r.data);
const put = (url, body) => v2Api.put(url, body).then((r) => r.data);
const del = (url) => v2Api.delete(url).then((r) => r.data);

export const badgeService = {
  catalog: (activeOnly = false) => get('/Badge/catalog', { params: { active_only: activeOnly } }),
  getById: (id) => get(`/Badge/${id}`),
  ownership: (id, tierLevel) =>
    get(`/Badge/${id}/ownership`, { params: tierLevel != null ? { tier_level: tierLevel } : undefined }),
  create: (payload) => post('/Badge', payload),
  update: (id, payload) => put(`/Badge/${id}`, payload),
  remove: (id) => del(`/Badge/${id}`),
  recalculate: (payload = {}) => post('/Badge/recalculate', payload),
  initialize: (activePlayersOnly = false) =>
    post(`/Badge/initialize?active_players_only=${activePlayersOnly ? 'true' : 'false'}`),
  playerBadges: (playerId) => get(`/Badge/player/${playerId}`),
  assign: (payload) => post('/Badge/assign', payload),
  removePlayerBadge: (playerBadgeId) => del(`/Badge/player-badge/${playerBadgeId}`),
};
